export default import.meta.ROLLUP_FILE_URL_OxZ3GWTSEBT3Qb_FBDNjZw